import useMachineTypeById from './useMachineTypeById';
import { useGroupById } from '../../groups/hooks/useGroupById';
import { CHANNEL_TYPE } from '../../reports/api/Report.model';
import getChannelNameByMachineType from '../util/getChannelNameByMachineType';
import { useMemo } from 'react';

function useChannelsFromComposableDevice(groupId: string) {
  const { data: group, ...rest } = useGroupById(groupId);
  const machineTypeId = group?.composableDevice?.machineTypeId;
  const { data: machineType } = useMachineTypeById(machineTypeId);
  const channels = useMemo(
    () =>
      group?.composableDevice?.channels?.map((channel) => ({
        composableDeviceId: group?.id,
        channelID: channel.channel,
        cuID: channel.controlUnitId,
        deviceID: channel?.deviceId,
        type:
          channel.channelType == 'sensordata'
            ? CHANNEL_TYPE.ANALOG
            : channel.channelType == 'event'
            ? CHANNEL_TYPE.DIGITAL
            : channel.channelType,
        name: getChannelNameByMachineType(group, machineType, channel),
      })) || [],
    [group?.composableDevice?.channels, group?.id, machineType]
  );
  return { data: channels, ...rest };
}

export default useChannelsFromComposableDevice;
